// extracted by mini-css-extract-plugin
export default {"heroSection":"Hero_heroSection__2JBV2","textSection":"Hero_textSection__KrIRN","heroImg":"Hero_heroImg__zb5aB"};